var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error" }, [
    _c(
      "div",
      { staticClass: "nav" },
      [
        _c("p", [_vm._v("4 0 4")]),
        _c("span", [_vm._v("页面未找到，请先清除浏览器缓存，再刷新页面或")]),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.handleGoback } },
          [_vm._v("返回上一页")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }